import { StyledCreditsLimitBanner } from '@common/credits/ProfessionalEdition/CreditsLimitBanner';
import { PageHeader } from '@common/Header/PageHeader';
import { Private_Routes } from '@common/url';
import { getObservabilityLabelName } from '@pages/Observation/util';
import { ActivityIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { Stack, StackItem } from '@prophecy/ui-v3/Layout';
import DocumentTitle from '@prophecy/utils/react/DocumentTitle';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';

import { useEnvConfig } from '../../context/envConfig';
import { SQLPipelineObservation } from './SQLPipeline';

const Content = styled(StackItem)`
  padding-left: ${theme.spaces.x56};
  padding-right: ${theme.spaces.x56};
  padding-top: ${theme.spaces.x40};
  padding-bottom: ${theme.spaces.x36};
  gap: ${theme.spaces.x8};
`;

export const NewObservationHome = () => {
  const envConfig = useEnvConfig();

  if (!envConfig.observability.enabled) {
    return <Navigate to={Private_Routes.Home.url} replace />;
  }

  const observabilityLabelName = getObservabilityLabelName();

  return (
    <>
      <DocumentTitle title={observabilityLabelName} />
      <Stack height='100%'>
        <PageHeader crumbs={[{ label: observabilityLabelName, icon: <ActivityIcon type='default' /> }]} />
        <StyledCreditsLimitBanner />
        <Content grow='1'>
          <SQLPipelineObservation />
        </Content>
      </Stack>
    </>
  );
};
